import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {GoalsController} from '@api/goals-api/goals-controller';
import {GoalsRequestImpl} from '@api/goals-api/goals-request';

const userName = (user: any) => {
  if (!user) return 'Unassigned';
  if (typeof user === 'string') return 'Assigned member';
  const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
  return fullName || user.email || 'Assigned member';
};

export const useParentGoalOptions = (enabled: boolean) => {
  const controller = useMemo(
    () => new GoalsController(new GoalsRequestImpl()),
    [],
  );

  const query = useQuery(
    ['create-goal-parent-options', 'active-goals'],
    () => controller.fetchGoals(1, 'networkLevel', 10_000),
    {
      enabled,
      staleTime: 0,
      refetchOnMount: 'always',
    },
  );

  const options = useMemo(() => {
    const response: any = query.data;
    const goals = Array.isArray(response)
      ? response
      : response?.goals || response?.results || [];

    return goals
      .filter((goal: any) => !goal.isKpi)
      .map((goal: any) => ({
        label: {
          goalType:
            String(goal.goalType).toLowerCase() === 'company'
              ? 'Company-wide'
              : goal.goalType,
          goalName: goal.name,
          assigneeName: userName(goal.assignee),
          assigneeAvatar: {
            src: goal.assignee?.avatar?.url || '',
            name: userName(goal.assignee),
            id: goal.assignee?.id,
          },
          date: goal.startDate,
          id: goal.id,
        },
        value: goal.id,
      }));
  }, [query.data]);

  return {...query, options};
};
